export default __webpack_public_path__ + "static/media/mermaid-warrior.65b8ddf7.jpg";